import { Fragment } from 'react'

import { Icon } from '@wartek-id/icon-v2'

import type {
  TFollowUpEvaluationDocumentStates,
  TPelaksanaanAppealableStep,
  TStatePelaksanaan,
} from 'types/kinerja-pelaksanaan'
import type { LangkahObservasi } from '../../constants/tahapanPelaksanaan'

type TahapanItemProps = {
  tahapan: LangkahObservasi
  index: number
  tahapanPelaksanaanLength: number
  progressPercentage: number
  ptkId?: string
  state?: TStatePelaksanaan
  latestFormState?: TFollowUpEvaluationDocumentStates
  appealState?: TPelaksanaanAppealableStep
}

const TahapanItem = ({
  tahapan,
  index,
  tahapanPelaksanaanLength,
  progressPercentage,
  ptkId,
  state,
  appealState,
  latestFormState,
}: TahapanItemProps) => {
  return (
    <Fragment key={tahapan.callToAction}>
      <tahapan.CardComponent
        {...tahapan}
        url={ptkId ? `${tahapan.url}/${ptkId}` : tahapan.url}
        progressPercentage={progressPercentage}
        ptkId={ptkId}
        state={state}
        latestFormState={latestFormState}
        appealState={appealState}
      />
      {index + 1 < tahapanPelaksanaanLength && <Icon>arrow_forward</Icon>}
    </Fragment>
  )
}

export default TahapanItem
